import React from 'react';

import CardItem from '../../../../../components/CardItem';
import formatterBR, { formatter } from "../../../../../functions/formatCurrency";

export default function BillsCardItem(props) {
    let formatterCurrency = props.currency && props.currency !== "BRL" ? formatter(props.currency) : formatterBR;

    return (
        <CardItem
            bodyOptions={
                <>
                    {
                        !props.payd ?
                            <>
                                {
                                    props.isLate ?
                                        <span className="tag strong red">ATRASADA</span>
                                        : []
                                }
                                {
                                    props.expiresToday ?
                                        <span className="tag strong blue">VENCE HOJE</span>
                                        : []
                                }
                            </>
                            :
                            <span className="tag green">PAGA</span>
                    }
                    <span className="tag">COD {props.code}</span>
                </>
            }
            onClick={props.onClick}
        >
            {
                props.empresa && props.empresa.nome ?
                <>
                    <h5><b>Empresa: {props.empresa.nome}</b> </h5>
                </>
                :
                null
            }
            {
                props.colaborador && props.colaborador.nome ?
                <>
                    <h5><b>Colaborador: {props.colaborador.nome}</b> </h5>
                </>
                :
                null
            }
            <h6><b>{props.descricao}</b></h6>
            {
                props.payd ?
                    <p>Valor pago: {formatterCurrency.format(props.paydValue)}</p>
                    :
                    props.expiresToday ?
                        // <p>Valor: R${String(props.value.toFixed(2)).replace(/\./g, ',')}</p>
                        <p>Valor total: {formatterCurrency.format(props.value)}</p>
                        :
                        <p>Vencimento: {props.dueDate ? props.dueDate.split('-').reverse().join('/') : ""}</p>
            }
        </CardItem>
    )
}